export const GET_CREDIT_CARD = 'get_credit_card';
export const GET_CREDIT_CARD_SUCCESS = 'get_credit_card_success';